import { render, staticRenderFns } from "./LmButton.vue?vue&type=template&id=13d98f08&scoped=true"
import script from "./LmButton.vue?vue&type=script&lang=js"
export * from "./LmButton.vue?vue&type=script&lang=js"
import style0 from "./LmButton.vue?vue&type=style&index=0&id=13d98f08&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d98f08",
  null
  
)

export default component.exports